import React from 'react';

const LoginLinkSent = ({ email }) => {
  return (
    <>
      <div className="row">
        <div className="text-center">
          <i className="fa fa-paper-plane-o"></i>
          <h2 className="mb-0 font-suisse-neue">Check your inbox</h2>
          <div>
            <p className="pb-10 text-center text-[16px]">
              We’ve just sent an email to <b>{email}</b>, if that address is registered in our
              system. Click the link it includes and you’ll be logged into your account.
            </p>
            <hr />
            <p className="text-center">This link will expire in 2 hours.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginLinkSent;
